// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_ORCS = [{
  id: 'orcs_hunter',
  factionId: FACTIONS.ORCS,
  name: 'Охотник за головами',
  priceNumens: 11000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.RED
  ]
}, {
  id: 'orcs_bog',
  factionId: FACTIONS.ORCS,
  name: 'Хозяйка топей',
  priceNumens: 25000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.ORANGE
  ]
}, {
  id: 'orcs_jungle',
  factionId: FACTIONS.ORCS,
  name: 'Высший охотник',
  priceNumens: 60000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.ORANGE,
  ]
}, {
  id: 'orcs_defender',
  factionId: FACTIONS.ORCS,
  name: 'Бастион',
  priceNumens: 90000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.ORANGE
  ]
}, {
  id: 'orcs_gold_legacy',
  factionId: FACTIONS.ORCS,
  name: 'Вождь ущелья',
  priceNumens: 110000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'orcs_ruby_legacy',
  factionId: FACTIONS.ORCS,
  name: 'Надзиратель',
  priceCrystals: 350,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
